<template>
  <div>
    <!-- BEGIN panel -->
    <div class="card  border-0 mb-3">
      <TaskPanel :task="task" :stats="stats">
      </TaskPanel>
      <div class="card-footer">
        <div class="justify-content-end" style="display: flex;justify-content: right;">
          <div>
            <button @click="$router.push(`/task/${task.id}/promote`);" class="btn btn-white  me-2"><i
                class="fas  fa-circle-chevron-up"></i>
              <span class="ms-1 hide-400">Поднять</span></button>
            <button v-show="task.status == `STOPPED` || task.status == `RESERVE`" @click="startTask(task.id);"
              class="btn btn-white  me-2"><i class="fas  fa-circle-play "></i><span
                class="hide-400 ms-1">Запустить</span></button>
            <button v-show="task.status == `PROGRESS`" @click="stopTask(task.id);" class="btn btn-white  me-2"><i
                class="fas fa-circle-pause "></i>
              <span class="hide-400 ms-1">Остановить</span></button>
            <button @click="$router.push(`/task/${id}/edit`);" class="btn btn-white  me-2"><i
                class="fas fa-pen-to-square "></i><span class="ms-1 hide-400">Редактировать</span></button>
            <button @click="removeTask(id)" class="btn btn-white "><i class="fas fa-trash-can "></i>
              <span class="ms-1 hide-400">Удалить</span></button>

          </div>
        </div>
      </div>
    </div>

    <b-tabs nav-wrapper-class="nav nav-tabs tab-responsive" content-class="panel mb-0 p-3 rounded-0">
      <CustomerTab :task="task" :jobs="jobs" :cnt="stats['REVIEW']" :title="`Проверяются`" :stats="['REVIEW']"
        subtitle="Задания, которые Вам нужно проверить" :badge="`badge bg-primary`">
      </CustomerTab>
      <CustomerTab :task="task" :jobs="jobs" :cnt="stats['PROGRESS']" :title="`Выполняются`" :stats="['PROGRESS']"
        subtitle="Задания, которые выполняюся в данный момент (деньги на них зарезервированы)" :badge="`badge bg-info`">
      </CustomerTab>
      <CustomerTab :task="task" :jobs="jobs" :cnt="stats['DECLINED']" :title="`Доработать`" :stats="['DECLINED']"
        subtitle="Задания, которые дорабатываются в данный момент" :badge="`badge bg-orange-400`">
      </CustomerTab>
      <CustomerTab :task="task" :jobs="jobs" :cnt="stats['ACCEPTED']" :title="`Оплачено`" :stats="['ACCEPTED']"
        subtitle="Задания, которые вы приняли и оплатили" :badge="`badge bg-green`">
      </CustomerTab>
      <CustomerTab :task="task" :jobs="jobs" :cnt="stats['ACCEPBYTIME']" :title="`Оплачено`" :stats="['ACCEPBYTIME']"
        subtitle="Задания, которые были приняты, так как время на проверку закончилось" :badge="`badge bg-lime`">
      </CustomerTab>
      <CustomerTab :task="task" :jobs="jobs" :cnt="stats['CANCELED']" :title="`Отменено`"
        :stats="['CANCELED', 'EXPIRED', 'REJECTED']"
        subtitle="Задания, которые были отменены. Деньги были возвращены в задание." :badge="`badge bg-gray-600`">
      </CustomerTab>
      <CustomerTab :task="task" :jobs="jobs" :cnt="stats['ARBITRAGE']" :title="`Арбитраж`" :stats="['ARBITRAGE']"
        subtitle="Задания, которые находятся на рассмотрении в арбитраже. Если модератор решит что исполнитель не прав, деньги будут возаращены Вам"
        :badge="`badge bg-danger`">
      </CustomerTab>
    </b-tabs>
    <!-- END panel -->
  </div>
</template>

<script>
import HTTP from "../http";
import {show_error, show_message} from "../message";

export default {
  data() {
    return {
      id: 0,
      mes: "",
      task: {link: 'link'},
      jobs: [{messages: []}],
      stats: {},
      status: "ACCEPTED"
    };
  },

  created() {
    this.id = this.$route.params.id
    this.fetchData('REVIEW');
  },

  mounted() {
    window.eventBus.$on('jobshow.update', (status) => {
      this.fetchData(status);
    })
    window.eventBus.$on('customer.chat.update', () => {
      this.fetchData(this.status);
    })
  },

  methods: {
    startTask(id) {
      if (confirm("Запустить задание? ")) {
        HTTP()
          .put(`/v2/task/${id}`, {change_status: 'PROGRESS'})
          .then((response) => {
            //this.$router.push(`/tasks/ALL`);
            this.fetchData(this.status, this.curr_page)
            show_message(this.$notify, response.data);
          })
          .catch((error) => {
            show_error(this.$notify, this.$refs.form, error.response.data)
          })
          .finally(() => {
            this.loading = false;
            this.$insProgress.finish();
          });
      }
      return;
    },
    stopTask(id) {
      if (confirm("Остановить задание? ")) {
        HTTP()
          .put(`/v2/task/${id}`, {change_status: 'STOPPED'})
          .then((response) => {
            //this.$router.push(`/tasks/ALL`);
            this.fetchData(this.status, this.curr_page)
            show_message(this.$notify, response.data);
          })
          .catch((error) => {
            show_error(this.$notify, this.$refs.form, error.response.data)
          })
          .finally(() => {
            this.loading = false;
            this.$insProgress.finish();
          });
      }
      return;
    },
    removeTask(id) {
      if (confirm("Вы уверены? ")) {
        HTTP()
          .delete("v2/task/" + id)
          .then((response) => {
            console.log(response);
            show_message(this.$notify, response.data);
            this.$router.push('/tasks/ALL')
          })
          .catch((error) => {
            show_error(this.$notify, this.$refs.form, error.response.data)
          });
      }
      return;
    },
    fetchData(status) {
      console.log('status', status)
      this.status = status
      this.loading = true;
      window.eventBus.$emit('jobshow.loading', true)
      this.$insProgress.start();
      HTTP()
        .get(`/task/${this.id}?status=${status}`)
        .then((resp) => {
          this.task = resp.data.task
          this.jobs = resp.data.jobs
          this.stats = resp.data.stats
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
          window.eventBus.$emit('jobshow.loading', false)
        });
    },
    jobUpdate(status, task_id, user_id) {
      this.loading = true;
      this.$insProgress.start();
      HTTP()
        .put(`/job/${this.id}`, {status, message: this.mes, task_id, user_id})
        .then((resp) => {
          console.log('resp', resp)
          this.mes = ''
          this.fetchData()
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    },
  }
}
</script>


<style>
.task-href {
  cursor: pointer;
  text-decoration: none;
  color: var(--bs-body-color);
}

.task-href:visited {
  color: var(--bs-body-color);
}

.task-href:hover {
  color: var(--bs-body-color);
}

@media (max-width: 550px) {
  .hide-400 {
    display: none;
  }
}

.tab-responsive ul {
  display: flex;
  flex-direction: row;
  width: 100%;
}


.tab-responsive li {
  width: 14.28571428571429%;
}
</style>